import React, { useCallback } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { FaPowerOff } from 'react-icons/fa';
import logoSwint from '../../assets/swintLogo.svg';
import { useAuth } from '../../contexts/authContext';
import { useSteps } from '../../contexts/stepContext';
import {
  Container,
  ContentImgs,
  ContentSection,
  Header,
  UserData,
} from './styles';

const BodyStep: React.FC = ({ children }) => {
  const { signOut } = useAuth();
  const { currentStep } = useSteps();

  const handleSignOut = useCallback(() => {
    signOut();
  }, []);

  return (
    <Container
      firstStep={currentStep === 1 && isMobileOnly}
      nextSteps={currentStep > 1 && isMobileOnly}
    >
      {isMobileOnly ? (
        <>
          <Header>
            <h1>Identificação por Documento</h1>
          </Header>
          <ContentSection>{children}</ContentSection>
        </>
      ) : (
        <>
          <ContentImgs>
            <img src={logoSwint} alt="" />
            <UserData>
              <button onClick={handleSignOut}>
                <FaPowerOff size={16} />
                Sair
              </button>
            </UserData>
          </ContentImgs>

          <Header>
            <h1>Sistema de placas</h1>
          </Header>
          <ContentSection>{children}</ContentSection>
        </>
      )}
    </Container>
  );
};

export default BodyStep;
